export const vodafoneRed = "#E60000";